import "regenerator-runtime/runtime"
import React from 'react'
import ReactDOM from 'react-dom'
import App from './card/App'
# ErrorBoundary = bugsnag.getPlugin('react')


ReactDOM.render(
	# <ErrorBoundary>
	# 	<App card={window.serverdata} />
	# </ErrorBoundary>,
	<App card={window.serverdata} />,
	document.getElementById('root')
)
